export default "__VITE_ASSET__39ff35ef__"